import React, { createContext, useContext, useState, useCallback, useEffect, useRef } from 'react'

const LanguageContext = createContext()

export const useLanguage = () => {
  const context = useContext(LanguageContext)
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider')
  }
  return context
}

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(null)
  const hasUserChanged = useRef(false)

  const changeLanguage = useCallback((lang) => {
    hasUserChanged.current = true
    setLanguage(lang)
  }, [])

  useEffect(() => {
    const detect = async () => {
      let detected = 'en'
      try {
        const res = await fetch('https://ipapi.co/country/')
        if (res.ok) {
          const cc = (await res.text()).trim().toUpperCase()
          // Если страна Россия (RU) — используем русский, иначе всегда английский
          if (cc === 'RU') {
            detected = 'ru'
          } else {
            detected = 'en'
          }
        }
      } catch (e) {
        // Тихо игнорируем ошибки (429, CORS, timeout)
      }

      // Не трогаем язык, если пользователь уже переключил его вручную
      if (hasUserChanged.current) {
        return
      }

      setLanguage(detected)
    }
    detect()
  }, [])

  // Пока язык не определён (первичный detect по IP), не рендерим детей,
  // чтобы не было видимого "перепрыгивания" с EN на RU.
  if (!language) {
    return null
  }

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  )
}

